export default __webpack_public_path__ + "static/media/img5.fc6fff42.webp";